module.exports = __webpack_public_path__ + "img/super.f8c6bab7.svg";